import { ComponentStyleConfig } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'
import { getFormComponentStyle } from './getFormComponentStyle'
import { DISABLED_OPACITY } from './constants'

export const Input: ComponentStyleConfig = {
  variants: {
    default: (props: Dict) => ({
      field: {
        ...getFormComponentStyle(props),
      },
    }),

    nonEditable: (props: Dict) => ({
      field: {
        fontWeight: '500',
        backgroundColor: 'inherit',
        color: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
      },
    }),

    auth: (props: Dict) => ({
      field: {
        _hover: {
          '&:not([disabled])': {
            borderColor: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
            borderWidth: 'thin',
          },
        },
        _active: {
          '&:not([disabled])': {
            borderColor: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
            borderWidth: 'thin',
          },
        },
        _focus: {
          '&:not([disabled])': {
            borderColor: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
            borderWidth: 'thin',
          },
        },
        _placeholder: {
          color: mode('rw1.text.light.0', 'rw1.text.dark.0')(props),
        },
        _disabled: {
          opacity: DISABLED_OPACITY,
        },
        _invalid: {
          _hover: {
            borderColor: 'inherit',
          },
        },
        backgroundColor: mode(
          'rw1.body.light.clean',
          'rw1.body.dark.clean',
        )(props),
        color: mode('rw1.text.light.6', 'rw1.text.dark.6')(props),
        fontWeight: '500',
        borderRadius: 'xl',
        borderWidth: 'thin',
        borderColor: mode(
          'rw1.text.secondary.2',
          'rw1.text.secondary.2',
        )(props),
      },
    }),
  },
  defaultProps: {
    variant: 'default',
  },
}
